// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 176 ? "barcode-detector" : chunkId) + "." + {"176":"5d38143f","213":"fc40f05b","455":"78297e41"}[chunkId] + ".chunk.js";
};